import React from "react";
import "./History.css";

function History() {
  return (
    <div>
      <div className="row banner">
        <div className="bannerinside">
          <div className="headtitle">
            <div className="title-icon">
              <span className="icon-ring">
                <img src="./images/image.png" alt="Darshan" />
              </span>
            </div>

            <div className="title-content">
              <span className="title-small">TEMPLE</span>
              <h2 className="texthead">Temple History</h2>

              <div className="title-divider">
                <span></span>
                <i>✦</i>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-">
        <div className="history-page">

          {/* HERO */}
          {/* <section className="history-hero">

            <div className="history-hero-overlay"></div>

            <div className="history-hero-content">

              <span className="history-eyebrow">
                ✦ HERITAGE & LEGACY ✦
              </span>

              <h1>
                Temple
                <span>History</span>
              </h1>

              <div className="history-ornament">
                <span></span>
                <i>✦</i>
                <span></span>
              </div>

              <p>
                A sacred legacy preserved through centuries of devotion,
                tradition and architectural grandeur.
              </p>

            </div>

          </section> */}


          {/* MAIN CONTENT */}
          <section className="history-section">

            <div className="history-layout">

              {/* LEFT CONTENT */}
              <article className="history-content">

                {/* <div className="history-title-block">

                  <span className="section-number">
                    01
                  </span>

                  <div>
                    <span className="small-title">
                      THE STORY OF A SACRED LANDMARK
                    </span>

                    <h2>
                      The History of
                      <span> Sree Padmanabhaswamy Temple</span>
                    </h2>
                  </div>

                </div> */}


                {/* INTRO */}
                <div className="history-intro">

                  <p className="hcontent">
                    The origin of the Temple of Sree Padmanabhaswamy is lost in antiquity. It is not possible to determine with any exactitude, from any reliable historical documents or other sources as to when and by whom the original idol of Sree Padmanabhaswamy was consecrated. The Temple has references in Epics and Puranas. Srimad Bhagavatha says that Balarama visited this Temple, bathed in Padmatheertham and made several offerings. Nammalwar, 9th century poet and one among the 12 Vaishnavite saints of the Alvar tradition, has composed ten hymns in praise of Lord Padmanabha. Some well known scholars, writers and historians, like the late Dr. L.A.Ravi Varma of Travancore, have expressed the view that this Temple was established on the first day of Kali Yuga (which is over 5000 years ago).
                  </p>

                </div>


                {/* QUOTE / HIGHLIGHT */}
                <div className="history-highlight">

                  <div className="quote-symbol">
                    “
                  </div>

                  <p>
                    The legends of the Temple are handed down
                    through the centuries.
                  </p>

                </div>


                <p className="hcontent">
                  One such legend which finds a place in the old palm leaf records of the Temple, as also in the famous grantha entitled “Ananthasayana Mahatmya”, mentions that it was consecrated by a Tulu Brahmin hermit named Divakara Muni. On the 950th year of Kali Yuga a reinstallation of the idol was done. In the 960th Kali year King Kotha Marthandan built the Abhisravana Mandapam.
                </p>


                {/* STORY HEADING */}
                <div className="story-heading">

                  <span></span>

                  <h3>
                    The Legend of Divakara Muni
                  </h3>

                  <span></span>

                </div>


                <p className="hcontent">
                  The story as narrated in the Ananthasayana Mahatmya goes as follows.
                </p>


                <p className="hcontent">
                  Divakara Muni was a great Vishnu Bhaktha. While at ‘Aanarthadesa’, he performed deep tapas. One day Maha Vishnu appeared before the sage as a lovely child. The charming child attracted the attention of the sage. He requested the God-child to stay with him. The child made his stay conditional. Accordingly, the Sanyasi should treat him with respect. On failing to do so, he would vanish at once. This was accepted and the child stayed with him.
                </p>


                <p className="hcontent">
                  The hermit gave him great care and tolerated the childish pranks. One day, when the sanyasi was in deep meditation at his prayers, the child took the ‘salagram’ which the sanyasi was using for worship and put it into his mouth and made such a nuisance of himself that Divakara Muni was greatly angered and could tolerate it no further. He thereupon chastised the child. In accordance with the earlier agreement, immediately the child ran away and disappeared from the spot.
                </p>


                {/* SACRED STORY CARD */}
                <div className="sacred-card">

                  <div className="sacred-card-icon">
                    ✦
                  </div>

                  <div>
                    <span>
                      THE SACRED WORDS
                    </span>

                    <p>
                      “If you wish to see me again, you will
                      find me again in Ananthankaadu”.
                    </p>
                  </div>

                </div>


                <p className="hcontent">
                  It was only then that Divakara Muni realized who his erstwhile child guest had been. The hermit was stricken with inconsolable grief and for many days followed what, he believed was the route taken by the child foregoing food, rest and sleep in the process.
                </p>


                <p className="hcontent">
                  Finally he reached a wooded area near the sea coast, caught a glimpse of the child disappearing into a huge ‘Ilappa’ tree. Immediately the tree fell into the ground and it assumed the form of Sree Maha Vishnu. The divine form had its head at ‘Thiruvallam’ and its feet at ‘Trippapur’.
                </p>


                <p className="hcontent">
                  Overawed by the majesty and the size of the divine form, which manifested before him, the Sanyasi prayed to the Lord to condense Himself in size so that he could behold Him. There upon the image of the Lord shrank to a size, three times the length of the Sanyasy’s Yoga Dand.
                </p>


                {/* SECOND STORY */}
                <div className="story-heading">

                  <span></span>

                  <h3>
                    The Tradition of the Offering
                  </h3>

                  <span></span>

                </div>


                <p className="hcontent">
                  His prayers had been granted. He immediately offered a raw mango in a coconut shell. The Lord ordained that poojas to Him should be conducted by Tulu Brahmins. To this day half the number of poojaris in this Temple represent Tulu region.
                </p>


                <p className="hcontent">
                  Another generally accepted version about the origin of the Temple relates it to the famous Namboothiri sanyasi Vilvamangalathu Swamiyar, whose name is linked with the histories of several temples in Southern India.
                </p>


                <p className="hcontent">
                  This Swamiyar was also a Vishnu bhaktha. The legend is almost identical with that of Divakara Muni referred above. It is said that, when Sree Maha Vishnu presented himself in the Ananthasayana rupa before the sage at Ananthankaadu, the latter had nothing worthwhile to offer Him.
                </p>


                <p className="hcontent">
                  From a mango tree standing nearby he plucked a few unripe mangoes and placed them in a coconut shell lying there and in all humility offered it as ‘nivedyam’ to the Lord. Even today salted mango forms a major offering.
                </p>


                {/* HISTORICAL TIMELINE */}
                <div className="timeline-section">

                  <div className="timeline-heading">

                    <span>
                      ✦ CHRONOLOGY
                    </span>

                    <h2>
                      A Journey Through
                      <strong> Time</strong>
                    </h2>

                  </div>


                  <div className="timeline">

                    <div className="timeline-item">

                      <div className="timeline-year">
                        1050
                      </div>

                      <div className="timeline-dot"></div>

                      <div className="timeline-content">
                        <h4>
                          Temple Reconstruction
                        </h4>

                        <p>
                          The Temple was reconstructed and its
                          management reorganized by the then ruler.
                        </p>
                      </div>

                    </div>


                    <div className="timeline-item">

                      <div className="timeline-year">
                        1375
                      </div>

                      <div className="timeline-dot"></div>

                      <div className="timeline-content">
                        <h4>
                          Alpasi Utsavam
                        </h4>

                        <p>
                          Records indicate that the ten-day
                          Alpasi Utsavam was conducted.
                        </p>
                      </div>

                    </div>


                    <div className="timeline-item">

                      <div className="timeline-year">
                        1461
                      </div>

                      <div className="timeline-dot"></div>

                      <div className="timeline-content">
                        <h4>
                          Ottakkal Mandapam
                        </h4>

                        <p>
                          The idol was reinstalled and the
                          magnificent single-stone Mandapam was created.
                        </p>
                      </div>

                    </div>


                    <div className="timeline-item">

                      <div className="timeline-year">
                        1566
                      </div>

                      <div className="timeline-dot"></div>

                      <div className="timeline-content">
                        <h4>
                          Foundation of the Gopuram
                        </h4>

                        <p>
                          The foundation for the magnificent
                          eastern Gopuram was laid.
                        </p>
                      </div>

                    </div>


                    <div className="timeline-item">

                      <div className="timeline-year">
                        1686
                      </div>

                      <div className="timeline-dot"></div>

                      <div className="timeline-content">
                        <h4>
                          The Great Fire
                        </h4>

                        <p>
                          A major fire accident almost completely
                          destroyed the Temple.
                        </p>
                      </div>

                    </div>


                    <div className="timeline-item">

                      <div className="timeline-year">
                        1729
                      </div>

                      <div className="timeline-dot"></div>

                      <div className="timeline-content">
                        <h4>
                          Marthanda Varma
                        </h4>

                        <p>
                          The great ruler Marthanda Varma became
                          King of Travancore and initiated major
                          Temple renovations.
                        </p>
                      </div>

                    </div>


                    <div className="timeline-item">

                      <div className="timeline-year">
                        1730+
                      </div>

                      <div className="timeline-dot"></div>

                      <div className="timeline-content">
                        <h4>
                          The Temple We See Today
                        </h4>

                        <p>
                          Major reconstruction, the Sreebalippura,
                          Gopuram, flag-staff and Padmatheertham
                          were undertaken during this period.
                        </p>
                      </div>

                    </div>

                  </div>

                </div>


                <p className="hcontent">
                  In 1730 the idol was again moved to ‘Balalaya’ prior to the renovation and reconstruction of the sanctum sanctorum. It took two years for completion. The old wooden idol was replaced by the one that we see today. Made of highly complex amalgam known as Katusarkarayogam, it contains 12008 Salagrams within it.
                </p>


                <p className="hcontent">
                  Most of what is seen today within the walls of the temple were constructed during this period. It is recorded that 4000 sculptors, 6000 labourers and 100 elephants worked for a period of 6 months to finish the construction of the Sreebalippura. This magnificent rectangular corridor built of solid stones protects the Deities during seeveli on rainy days.
                </p>


                {/* FINAL FACTS */}
                {/* <div className="history-facts">

                  <div>
                    <strong>12008</strong>
                    <span>Salagrams</span>
                  </div>

                  <div>
                    <strong>4000</strong>
                    <span>Sculptors</span>
                  </div>

                  <div>
                    <strong>6000</strong>
                    <span>Labourers</span>
                  </div>

                  <div>
                    <strong>100</strong>
                    <span>Elephants</span>
                  </div>

                </div> */}

              </article>


              {/* RIGHT IMAGE */}
              <aside className="history-sidebar">

                <div className="history-image-card">

                  <div className="history-image">
                    <img
                      src="./images/spst.webp"
                      alt="Sree Padmanabhaswamy Temple"
                    />
                  </div>

                  <div className="history-image-caption">

                    <span>
                      SREE PADMANABHASWAMY TEMPLE
                    </span>

                    <p>
                      A timeless symbol of devotion,
                      heritage and architectural grandeur.
                    </p>

                  </div>

                </div>


                <div className="history-side-card">

                  <span>HERITAGE</span>

                  <strong>
                    Centuries of
                    <br />
                    Sacred Tradition
                  </strong>

                  <div className="side-card-line"></div>

                  <p>
                    The Temple's history lives through its
                    architecture, rituals, legends and
                    generations of devotees.
                  </p>

                </div>

              </aside>

            </div>

          </section>

        </div>
        {/* <div class="row">
          <div class="history">
            <div style={{ width: '70%', padding: '50px', boxShadow: '0px 0px 15px silver' }}>
              <h3 className="hheading">Temple History</h3>
              <p className="hcontent">
                The origin of the Temple of Sree Padmanabhaswamy is lost in antiquity. It is not possible to determine with any exactitude, from any reliable historical documents or other sources as to when and by whom the original idol of Sree Padmanabhaswamy was consecrated. The Temple has references in Epics and Puranas. Srimad Bhagavatha says that Balarama visited this Temple, bathed in Padmatheertham and made several offerings. Nammalwar, 9th century poet and one among the 12 Vaishnavite saints of the Alvar tradition, has composed ten hymns in praise of Lord Padmanabha. Some well known scholars, writers and historians, like the late Dr. L.A.Ravi Varma of Travancore, have expressed the view that this Temple was established on the first day of Kali Yuga (which is over 5000 years ago). The legends of the Temple are handed down through the centuries. One such legend which finds a place in the old palm leaf records of the Temple, as also in the famous grantha entitled “Ananthasayana Mahatmya”, mentions that it was consecrated by a Tulu Brahmin hermit named Divakara Muni. On the 950th year of Kali Yuga a reinstallation of the idol was done. In the 960th Kali year King Kotha Marthandan built the Abhisravana Mandapam..
              </p>
              <p className="hcontent">The story as narrated in the Ananthasayana Mahatmya goes as follows.</p>
              <p className="hcontent">
                Divakara Muni was a great Vishnu Bhaktha. While at ‘Aanarthadesa’, he performed deep tapas. One day Maha Vishnu appeared before the sage as a lovely child. The charming child attracted the attention of the sage. He requested the God-child to stay with him. The child made his stay conditional. Accordingly, the Sanyasi should treat him with respect. On failing to do so, he would vanish at once. This was accepted and the child stayed with him. The hermit gave him great care and tolerated the childish pranks. One day, when the sanyasi was in deep meditation at his prayers, the chills took the ‘salagram’ which the sanyasi was using for worship and put it into his mouth and made such a nuisance of himself that Divakara Mini was greatly angered and could tolerate it no further. He thereupon chastised the child. In accordance with the earlier agreement, immediately the child ran away and disappeared from the spot. While going he said, “If you wish to see me again, you will find me again in Ananthankaadu”. It was only then that Divakara Muni realized who his erstwhile child guest had been. The hermit was stricken with inconsolable grief and for many days followed what, he believed was the route taken by the child foregoing food, rest and sleep in the process.

                Finally he reached a wooded area near the sea coast, caught a glimpse of the child disappearing into a huge ‘Ilappa’ tree. Immediately the tree fell into the ground and it assumed the form of Sree Maha Vishnu. The divine form had its head at ‘Thiruvallam’(a place about 3 miles from East Fort at where the Temple of Sree Padmanabha Swamy is located) and its feet at ‘Trippapur’ (5 miles away towards the north). Overawed by the majesty and the size of the divine form, which manifested before him, the Sanyasi prayed to the Lord to condense Himself in size so that he could behold Him. There upon the image of the Lord shrank to a size, three times the length of the Sanyasy’s Yoga Dand. His prayers had been granted. He immediately offered a raw mango in a coconut shell(still this offering continues). The Lord ordained that, poojas to Him should be conducted by Tulu Brahmins. To this day half the number of poojaris(priests) in this Temple represent Tulu region. Another generally accepted version about the origin of the Temple relates it to the famous Namboothiri sanyasi Vilvamangalathu Swamiyar, whose name is linked with the histories of several temples in Southern India. This Swamiyar was also a Vishnu bhaktha. The legend is almost identical with that of Divakara Muni referred above. It is said that, when Sree Maha Vishnu presented himself in the Ananthasayana rupa (in the form of reclining on Anantha) before the sage at Ananthankaadu, the latter had nothing worthwhile to offer Him. From a mango tree standing nearby he plucked a few unripe mangoes and placed them in a coconut shell lying there and in all humility offered it as ‘nivedyam’ to the Lord. Even today salted mango forms a major offering. The original coconut shell has been encased in gold. It has also been the practice in the Temple for the past several centuries that the morning ‘pushpanjali’ is to be performed by a Namboothiri Brahmin sanyasi (designated Pushpanjaly Swamiyar) specially commissioned for this purpose.

                These traditional customs coupled with the fact that the Pushpanjali Swamiyar holds a position of importance in the ‘Ettara Yogam’ (a committee which, at one time in the distant past, was the governing body of the Temple but has, over the years, become a ceremonial and advisory panel) lend substance and some measures of credence to the theory that this Temple was founded by Vilvamangalathu Swamiyar. On the other hand the legend of the Divakara Muni can be substantiated by the presence of a large number of Tulu Brahmins. Besides being represented in the ‘Yogam’, the Namboothiri Brahmins also have a position of eminence in the rituals and ceremonies of theTtemple . The Tantries(high priests) have always been from the Tharananalloor family belonging to this community. It is also believed that the small Sree Krishna Swamy Temple, located near the Western Swamiyar Madham (residence of one of the two Pushpanjali Swamiyars of the Temple) has been built over the Samadhi of Vilvamangalathu Swamiyar. Some historians and researchers hold the view that the Thiruvambadi shrine of Sree Krishna Swamy is older than the shrine of Sree Padmanabhaswamy. According to legend the Sree Narasimhaswamy and Sree Sastha shrines were established after the installation of the idol of Lord Sree Padmanabhaswamy. There is mention in the ‘Bhagavatha Purana’ (canto 10, chapter 79) that Sree Balarama visited “Syanandoorapuram” or “Ananthasayam” (Thiruvananthapuram) in the course of His pilgrimage. Similarly in the ‘Brahmanda Purana’ also there is a reference to “Syanandoorapura”. These references show that this Temple is of great antiquity and has been held in veneration over the centuries as an important seat of Sree Maha Vishnu. The compositions of Nammalvar, the great Vaishnavite saint, in praise of Sree Maha Vishnu of this city, prove beyond doubt that this Temple existed in the ninth century of this era. In the year 1050A.D.(225ME), the Temple was reconstructed and the management re-organized by the then ruler.

                The next important recorded events relate to the period between 1335 A.D. and 1384 A.D. when Venad was ruled by a powerful and wise king named Veera Marthanda Varma. He gradually established his authority completely over the management and administration of the Temple. There are records to indicate that in the year 1375 A.D. the Alpasi Utsavam (ten days festival held in October-November) was conducted in the Temple. Some of the important events relating to the Temple which took place after the demise of this ruler until 1729 A.D. are given below.

                Between 1459 A.D. and 1460 A.D. the idol of Sree Padmanabhaswamy was removed to a ‘Balalaya’ for the purpose of re-construction of the roof of the sanctum sanctorum.
                In 1461 A.D. the idol was re installed and an Ottakkal Mandapam (Single granite stone slab abutting the sanctum sanctorum) was put up.
                In 1566 A.D. the foundation was laid for the Gopuram (pagoda) over the main eastern entrance.
                In 1686 A.D. the Temple was almost fully destroyed in a major fire accident. Work on the re- construction of the Temple was started only in 1724.
                In 1728 A.D. propitiatory ceremonies, connected with the serious fire of 1686, were conducted.
                It was in the year 1729 that the great ruler Marthanda Varma became the king of Travancore. He took the steps to renovate the Temple. In 1730 the idol was again moved to ‘Balalaya’ prior to the renovation and reconstruction of the sanctum sanctorum. It took two years for completion. The old wooden idol was replaced by the one that we see today. Made of highly complex amalgam known as Katusarkarayogam, it contains 12008 Salagrams within it. Most of what is seen today within the walls of the temple were constructed. It is recorded that 4000 sculptors, 6000 labourers and 100 elephants worked for a period of 6 months to finish the construction of the sreebalippura (the oblong corridor). This magnificent rectangular corridor built of solid stones protects the Deities during seeveli on rainy days. The gopuram for which the foundation had been laid in 1566, was built during this period. Similarly the flag-staff in front of the main shrine was also erected at this time. Teak wood of required size was brought from the forest for this purpose and transported to the Temple in such a way that no part of the wood touched the ground. The pole was then covered completely with gold sheets. The renovation of the Temple tank, the Padmatheertham, including the flight steps and its completion in the form we see it today was also undertaken during this great ruler’s time.
              </p>
            </div>
            <div style={{ width: '25%', backgroundImage: 'url(./images/spst.webp)', backgroundSize: 'cover', backgroundAttachment: 'fixed', backgroundPosition: 'center center' }}>
              <p>
                sfgf
              </p>
            </div>
          </div>

        </div> */}
      </div>
    </div>
  );
}

export default History;
